import type { ColumnsType } from "antd/es/table";
import { langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";
import { floatNumberInThousands } from "../../../utils/tools"

const lang = langPage?.card.transaction;

const renderPrice = (val: number | string) => {
    return floatNumberInThousands(val) || ''
}

export const DEFAULT_QUERY_DATA = {
    UdpayMaskedCardNumber: null,
    MemberId: null,
    Email: null,
    TransactionType: null,
    TransactionStatus: null,
    CardholderEmail: null
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    return [
        {
            title: '遮罩卡号后四位',
            type: "input",
            field: "UdpayMaskedCardNumber",
            allowClear: true,
        },
        {
            title: '用户邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '持卡人邮箱',
            type: "input",
            field: "CardholderEmail",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        {
            title: lang?.transactionType,
            type: "select",
            field: "TransactionType",
            allowClear: true,
            style: { width: 200 },
            options: [
                { id: 'AUTHORIZATION', name: 'AUTHORIZATION', },
                { id: 'REFUND', name: 'REFUND', },
                { id: 'REVERSAL', name: 'REVERSAL', }
            ],
        },
        {
            title: lang?.transactionStatus,
            type: "select",
            field: "TransactionStatus",
            allowClear: true,
            style: { width: 200 },
            options: [
                { id: 'APPROVED', name: 'APPROVED', },
                { id: 'DECLINED', name: 'DECLINED', },
            ],
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    return [
        {
            title: '卡号',
            dataIndex: "MemberCard",
            render(value, record, index) {
                return value?.UdpayMaskedCardNumber
            },
        },
        {
            title: '卡片uuid',
            dataIndex: "UdpayCardId",
        },
        {
            title: lang?.billingAmount,
            dataIndex: "BillingAmount",
            render: renderPrice
        },
        {
            title: lang?.billingCurrency,
            dataIndex: "BillingCurrency",
        },
        {
            title: lang?.cardAvailableBalance,
            dataIndex: "CardAvailableBalance",
            render: renderPrice
        },
        {
            title: lang?.failureReason,
            dataIndex: "FailureReason",
        },
        {
            title: langPage?.card.main.member,
            dataIndex: "Member",
            render(value, record, index) {
                return value?.Email || ''
            },
        },
        {
            title: lang?.transactionAmount,
            dataIndex: "TransactionAmount",
            render: renderPrice
        },
        {
            title: lang?.transactionCurrency,
            dataIndex: "TransactionCurrency",
        },
        {
            title: lang?.transactionFee,
            dataIndex: "TransactionFee",
            render: renderPrice
        },
        {
            title: lang?.transactionStatus,
            dataIndex: "TransactionStatus",
        },
        {
            title: lang?.transactionType,
            dataIndex: "TransactionType",
        },
        {
            title: "商户名称",
            dataIndex: "MerchantName",
        },
        {
            title: "备注",
            dataIndex: "Description",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
    ]
}


